<script setup>
import { useEnfantStore } from '@/plugins/store/enfant.ts'
import { ref } from 'vue';

const dialog = ref(false); // État pour contrôler l'affichage de la modale

const updateEnfant = () => {
  dialog.value = true;
};

const store = useEnfantStore()
store.getEnfants()

</script>

<template>
  <div>
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="store.nouveauEnfant.prenom"
              :counter="10"
              label="Prénom"
              hide-details
              required
            ></v-text-field>
          </v-col>
          
          <v-col cols="12" md="2">
            <v-text-field
              v-model="store.nouveauEnfant.nom"
              :counter="10"
              label="Nom"
              hide-details
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="2">
            <v-text-field
              type="datetime-local"
              v-model="store.nouveauEnfant.date_de_naissance"
              label="Date"
              required
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-btn
              :loading="loading"
              @click="store.sauvegardeEnfant()"
          >Sauvegarder</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>

  <div>
    <v-row v-for="(enfant, index) in store.enfants" v-bind:key="`${index}-${enfant}`" @click="updateEnfant">
      <v-col>
        {{ enfant.nom }}
      </v-col>
      <v-col>
        {{ enfant.prenom }}
      </v-col>
      <v-col>
        {{ enfant.date_de_naissance }}
      </v-col>
    </v-row>
  </div>

  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ props }">
      <!-- Si vous voulez activer la modale via un autre élément -->
      <v-btn v-bind="props">Ouvrir la modale</v-btn>
    </template>

    <!-- Contenu de la modale -->
    <v-card>
      <v-card-title>Titre de la modale</v-card-title>
      <v-card-text>
        Contenu de la modale...
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog = false">Fermer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>